import { type VectorLayer } from '@meitu/saas-editor-core/es/layers/vector-layer';
import { type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { FontSizeSelector } from '@/components/font-size-selector';
import { useEditor } from '@/hooks/use-editor';
import { useGlobalWidget } from '@/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { type WidgetCommonProps } from '../../types';
import { Tracker } from '../../utils';

type Props = WidgetCommonProps;

const FALLBACK_FONT_SIZE = 6;

export const FontSize: React.FC<Props> = ({ layerId, recordId }) => {
    const editor = useEditor();
    const fontSize = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as IVectorLayerProps;
        const { textInfo } = layerData;

        return textInfo ? textInfo.fontSize : null;
    }) as number | null;

    const popoverWidgetRef = useGlobalWidget(editor, false);

    const handleOpenChange = (open: boolean) => {
        popoverWidgetRef.current = open;
    };

    const handleChange = (value: number, options = { writeHistory: false }) => {
        editor.getInstance<VectorLayer>('VectorLayer').setFontSize(layerId, value, options);

        if (options.writeHistory) {
            Tracker.setFontSize({
                recordId,
                stageType: editor.services.editor.getCanvasType(),
                fontSize: value,
                isVectorLayer: true,
            });
        }
    };

    return (
        <FontSizeSelector
            value={fontSize || FALLBACK_FONT_SIZE}
            onChange={(value) => handleChange(value, { writeHistory: false })}
            onAfterChange={(value) => handleChange(value, { writeHistory: true })}
            onOpenChange={handleOpenChange}
        />
    );
};
